"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgAmenityWheelchair = function SvgAmenityWheelchair(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M971.2 630.4c-12.8-12.8-38.4-12.8-54.4 0l-48 48-160-134.4-3.2-3.2h-3.2s-3.2 0-3.2-3.2H465.6v-96h220.8c19.2 0 38.4-16 38.4-38.4s-16-38.4-38.4-38.4H465.6v-80c60.8-19.2 99.2-76.8 99.2-137.6C564.8 64 497.6 0 417.6 0s-144 64-144 144c0 70.4 48 128 115.2 140.8v281.6c0 19.2 16 38.4 38.4 38.4h246.4l176 150.4h3.2s3.2 0 3.2 3.2c0 0 3.2 0 3.2 3.2H891.2s3.2 0 3.2-3.2c0 0 3.2 0 3.2-3.2l73.6-73.6c12.8-12.8 12.8-38.4 0-51.2zm-553.6-416c-38.4 0-70.4-32-70.4-70.4 0-38.4 32-70.4 70.4-70.4 38.4 3.2 70.4 32 70.4 70.4 0 38.4-32 70.4-70.4 70.4zm348.8 604.8c3.2 12.8 0 22.4-3.2 28.8-73.6 112-195.2 176-326.4 176-214.4 0-390.4-176-393.6-387.2 0-131.2 67.2-252.8 176-326.4 9.6-6.4 19.2-9.6 28.8-6.4 12.8 0 19.2 6.4 25.6 16 6.4 9.6 9.6 19.2 6.4 28.8-3.2 9.6-6.4 16-16 22.4-86.4 57.6-140.8 156.8-140.8 262.4 0 172.8 140.8 313.6 313.6 313.6 105.6 0 204.8-51.2 262.4-140.8 9.6-16 35.2-22.4 51.2-9.6 9.6 3.2 12.8 12.8 16 22.4z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgAmenityWheelchair, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;